<app-timeout></app-timeout>
<div class="container-fluid app-content-view">
  <form #form="ngForm">
    @if (dataLoaded) {
      <div class="edit-employee-container">
        <div class="opm-grid">
          @if (!isAudit) {
            <div class="grid-caption">
              Update Employee Profile
              @if (profile.Errors.length > 0) {
                <a class="icon revert-error" href="#"
                  >
                  <ul>
                    @for (error of profile.Errors; track error) {
                      <li>
                        {{error}}
                      </li>
                    }
                  </ul>
                </a>
              }
            </div>
          }
          <div class="grid-item">
            <span class="field">Global Person Id (EMPGUID)</span>
            <span class="value">{{profile.Origin?.GlobalPersonId}}</span>
            <span class="value">{{profile.Override.GlobalPersonId}}</span>
          </div>
          <div class="grid-item">
            <span class="field">Person Id (EmpCode)</span>
            <span class="value">{{profile.Origin?.PersonId}}</span>
            <span class="value">{{profile.Override.PersonId}}</span>
          </div>
          <div class="grid-item">
            <span class="field">Member Firm Code</span>
            <span class="value">{{profile.Origin?.MemberFirmCode}}</span>
            <span class="value">
              <select class="form-control" [(ngModel)]="profile.Override.MemberFirmCode" name="memberFirmCode">
                @for (code of dictionaries.MemberFirms; track code) {
                  <option>
                    {{code}}
                  </option>
                }
              </select>
            </span>
          </div>
          <div class="grid-item">
            <span class="field">Country Code - Description</span>
            <span class="value">{{profile.Origin?.CountryCode}} - {{profile.Origin?.CountryDesc}}</span>
            <span class="value">
              <select class="form-control" [(ngModel)]="selectedCountry" (change)="changeCountry()" name="countryCode">
                @for (country of dictionaries.Countries; track country) {
                  <option [ngValue]="country">
                    {{country.Code}} - {{country.Description}}
                  </option>
                }
              </select>
            </span>
          </div>
          <div class="grid-item">
            <span class="field" [ngClass]="{'has-error': form.controls.firstName?.invalid}">First Name</span>
            <span class="value">{{profile.Origin?.FirstName}}</span>
            <span class="value">
              <input type="text"
                class="form-control"
                name="firstName" maxlength="75"
                [(ngModel)]="profile.Override.FirstName"
                required #firstName="ngModel">
              </span>
            </div>
            <div class="grid-item">
              <span class="field" [ngClass]="{'has-error': form.controls.lastName?.invalid}">Last Name</span>
              <span class="value">{{profile.Origin?.LastName}}</span>
              <span class="value">
                <input type="text" class="form-control"
                  name="lastName" maxlength="75"
                  [(ngModel)]="profile.Override.LastName"
                  required #lastName="ngModel">
                </span>
              </div>
              <div class="grid-item">
                <span class="field">Preferred Full Name</span>
                <span class="value full-name">{{profile.Origin?.LastName}}, {{profile.Origin?.FirstName}}</span>
                <span class="value full-name">{{profile.Override.LastName}}, {{profile.Override.FirstName}}</span>
              </div>
              <div class="grid-item">
                <span class="field" [ngClass]="{'has-error': form.controls.outlookName?.invalid}">Outlook Display Name</span>
                <span class="value full-name">{{profile.Origin?.OutlookDisplayName}}</span>
                <span class="value">
                  <input type="text" class="form-control"
                    name="outlookName" maxlength="300"
                    [(ngModel)]="profile.Override.OutlookDisplayName"
                    required #outlookName="ngModel">
                  </span>
                </div>
                <div class="grid-item">
                  <span class="field" [ngClass]="{'has-error': form.controls.employeeAlias?.invalid}">Employee Alias</span>
                  <span class="value">{{profile.Origin?.EmployeeAlias}}</span>
                  <span class="value">
                    <input type="text"
                      class="form-control"
                      name="employeeAlias" maxlength="100"
                      [(ngModel)]="profile.Override.EmployeeAlias"
                      required #employeeAlias="ngModel">
                    </span>
                  </div>
                  <div class="grid-item">
                    <span class="field" [ngClass]="{'has-error': form.controls.emailAddress?.invalid}">Email</span>
                    <span class="value">{{profile.Origin?.Email}}</span>
                    <span class="value">
                      <input type="text"
                        class="form-control"
                        name="emailAddress" [pattern]="emailPattern" maxlength="150"
                        [(ngModel)]="profile.Override.Email"
                        required #emailAddress="ngModel">
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Office Code - Description</span>
                      <span class="value">{{profile.Origin?.OfficeCode}} - {{profile.Origin?.OfficeDesc}}</span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="selectedOffice" (change)="changeOffice()" name="officeCode">
                          @for (office of dictionaries.Offices; track office) {
                            <option [ngValue]="office">
                              {{office.Code}} - {{office.Description}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Job Title</span>
                      <span class="value">{{profile.Origin?.JobTitle}}</span>
                      <span class="value">{{profile.Override.JobTitle}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Employee Type</span>
                      <span class="value">{{profile.Origin?.EmployeeType}}</span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="profile.Override.EmployeeType" name="employeeType">
                          @for (code of dictionaries.EmployeeTypes; track code) {
                            <option [value]="code">
                              {{code}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Employee Status Code - Description</span>
                      <span class="value">{{profile.Origin?.EmployeeStatusCode}} - {{profile.Origin?.EmployeeStatusDesc}}</span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="selectedStatus" (change)="changeStatus()" name="statusCode">
                          @for (status of dictionaries.Statuses; track status) {
                            <option [ngValue]="status">
                              {{status.Code}} - {{status.Description}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Work Phone</span>
                      <span class="value">{{profile.Origin?.WorkPhone}}</span>
                      <span class="value">{{profile.Override.WorkPhone}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Mobile Phone</span>
                      <span class="value">{{profile.Origin?.MobilePhone}}</span>
                      <span class="value">{{profile.Override.MobilePhone}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Organization Code - Description</span>
                      <span class="value">{{profile.Origin?.OrganizationCode}} - {{profile.Origin?.OrganizationDesc}}</span>
                      <span class="value">
                        <select class="form-control" [(ngModel)]="selectedOrganization" (change)="changeOrganization()" name="organizationCode">
                          @for (organization of dictionaries.Organizations; track organization) {
                            <option [ngValue]="organization">
                              {{organization.Code}} - {{organization.Description}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">PPMD</span>
                      <span class="value">
                        {{profile.Origin?.PPMD | booleanFormatterPipe}}
                      </span>
                      <span class="value">
                        <select class="form-control"
                          [ngModel]="profile.Override.PPMD"
                          (ngModelChange)="profile.Override.PPMD = parseBoolean($event)"
                          name="isPPMD">
                          @for (isPPMD of [true, false]; track isPPMD) {
                            <option [value]="isPPMD">
                              {{isPPMD | booleanFormatterPipe}}
                            </option>
                          }
                        </select>
                      </span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Region</span>
                      <span class="value">{{profile.Origin?.Region}}</span>
                      <span class="value">{{profile.Override.Region}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Personnel Area Code - Description</span>
                      <span class="value">{{profile.Origin?.PersonnelAreaCode}} - {{profile.Origin?.PersonnelAreaDesc}}</span>
                      <span class="value">{{profile.Override.PersonnelAreaCode}} - {{profile.Override.PersonnelAreaDesc}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Master Cost Center Number</span>
                      <span class="value">{{profile.Origin?.MasterCostCenterNumber}}</span>
                      <span class="value">{{profile.Override.MasterCostCenterNumber}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Master Cost Center Name</span>
                      <span class="value">{{profile.Origin?.MasterCostCenterName}}</span>
                      <span class="value">{{profile.Override.MasterCostCenterName}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Cost Center Firm Function Code - Description</span>
                      <span class="value">{{profile.Origin?.CostCenterFirmFunctionCode}} - {{profile.Origin?.CostCenterFirmFunctionDesc}}</span>
                      <span class="value">{{profile.Override.CostCenterFirmFunctionCode}} - {{profile.Override.CostCenterFirmFunctionDesc}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field">Previous Person Id</span>
                      <span class="value">{{profile.Origin?.PreviousEmployeeCode}}</span>
                      <span class="value">{{profile.Override.PreviousEmployeeCode}}</span>
                    </div>
                    <div class="grid-item">
                      <span class="field" [ngClass]="{'has-error': form.controls.comments?.invalid}">Comments</span>
                      <span class="value"><span>{{profile.Origin?.Comment}}</span></span>
                      <span class="value">
                        <input type="text"
                          class="form-control"
                          name="comments" maxlength="4000"
                          [(ngModel)]="profile.Override.Comment"
                          required #comments="ngModel">
                        </span>
                      </div>
                      <div class="grid-item">
                        <span class="field" [ngClass]="{'has-error': form.controls.ticketNumber?.invalid}">SN Ticket Number</span>
                        <span class="value"><span>{{profile.Origin?.TicketNumber}}</span></span>
                        <span class="value">
                          <input type="text"
                            class="form-control"
                            name="ticketNumber" maxlength="100"
                            [(ngModel)]="profile.Override.TicketNumber"
                            required #ticketNumber="ngModel">
                          </span>
                        </div>
                        @if (readWriteAccessData) {
                          <button type="button" class="btn btn-primary pull-right" [disabled]="form.invalid" (click)="save()">Save</button>
                        }
                        @if (readWriteAccessData && (profile.Override.OverrideStatus == overrideStatusEnum.Modified)) {
                          <button type="button"
                            class="btn btn-revert pull-right"
                            (click)="visiblMessagePopup = true"
                            [disabled]="profile.Errors.length > 0">
                            Revert
                          </button>
                        }
                        <button type="button" class="btn btn-light pull-right" routerLink="">Cancel</button>
                      </div>
                    </div>
                  }
                </form>
                @if (visiblMessagePopup) {
                  <opm-modal-popup
                    header="Revert record modification"
                    message="By Reverting this record all values will be updated to the latest OPM feed. Are you sure you want to Revert?"
                    (onOk)="revert(userId)"
                    okButtonName="Revert"
                    (onCancel)="visiblMessagePopup = false">
                  </opm-modal-popup>
                }
                @if (visiblErrorPopup) {
                  <opm-modal-popup
                    header="Error"
                    [cancelVisibility]="false"
                    [message]="errorMessage"
                    okButtonName="Ok"
                    (onOk)="visiblErrorPopup = false">
                  </opm-modal-popup>
                }
              </div>
              <opm-footer></opm-footer>

